import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} heimasíða nafnlauss spjalls`,
    languageButtonLabel: `Tungumál`,
    languageModalTitle: `Veldu tungumál`,
    languageModalCloseLabel: `Loka tungumálavalmynd`,
  },
  languageOptions: {
    'en-US': {
      label: `Enska (Bandaríkin)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Enska (Kenía)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Enska (Nígería)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Enska (Singapúr)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portúgalska (Portúgal)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Portúgalska (Brasilía)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Þýska (Þýskaland)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Þýska (Austurríki)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Þýska (Sviss)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Spænska (Spánn)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Franska (Frakkland)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Ítalska (Ítalía)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Hollenska (Holland)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Pólska (Pólland)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Sænska (Svíþjóð)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Danska (Danmörk)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Finnska (Finnland)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norska (Noregur)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska (Ísland)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japanska (Japan)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Kóreska (Suður-Kórea)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Kínverska (Kína)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Kantónska (sérstjórnarsvæðið Hong Kong)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Víetnamska (Víetnam)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Taílenska (Taíland)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indónesíska (Indónesía)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Svahílí (Kenía)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindí (Indland)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengalska (Bangladess)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Maratí (Indland)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Telúgú (Indland)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Persneska (Íran)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Úrdú (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Púnjabí (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Nígerískt pidgin (Nígería)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Rússneska (Rússland)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arabíska (Sádi-Arabía)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Arabíska (Sameinuðu arabísku furstadæmin)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Arabíska (Katar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Marokkóarabíska (Marokkó)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Tyrkneska (Tyrkland)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Veldu tungumál`,
    closeLabel: `Loka tungumálavalmynd`,
  },
  languageHint: (ctx) => `Skiptu á ${ctx.localesCount}+ tungumálum án þess að búa til aðgang.`,
  readPagePrompt: ({languageLabel}) => `Lestu þessa síðu á ${languageLabel}.`,
};
